package com.clany.backoffice.data.network.response

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ServiceAuthEntity(
    @SerialName("access_token")
    val accessToken: String? = null,
    @SerialName("expires_in")
    val expiresIn: Int? = null,
    @SerialName("refresh_expires_in")
    val refreshExpiresIn: Int? = null,
    @SerialName("refresh_token")
    val refreshToken: String? = null,
    @SerialName("token_type")
    val tokenType: String? = null,
    @SerialName("not-before-policy")
    val policy: Int? = null,
    @SerialName("session_state")
    val sessionState: String? = null,
    @SerialName("scope")
    val scope: String? = null,
    @SerialName("id_token")
    val idToken: String? = null,

    // Error fields
    @SerialName("error")
    val error: String? = null,
    @SerialName("error_description")
    val errorDescription: String? = null,
)
